import {
  AggregateDataverseChartDataSource,
  QueryAggregate,
  ChartType,
  type ChartClickEventArgs,
} from '@powerportalspro/react-charts';
import { DataverseChart } from '@powerportalspro/react-fluent';
import { useT } from '@powerportalspro/react';
import { useMemo, useState } from 'react';

const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Charts.BarChart.BarChartLinkedEntityDemo';

// Group-by-via-linked-entity: the opportunity table doesn't carry an
// `industrycode` column directly, so the chart joins through account
// (`customerid` → `account.accountid`) and groups by the account's
// industrycode. Same shape as the Blazor demo's
// `GroupByLinkedEntity = new ChartLinkedEntity { ... }` setup.
export function BarChartLinkedEntitySample() {
  const t = useT();
  const [lastClick, setLastClick] = useState<ChartClickEventArgs | null>(null);
  const source = useMemo(
    () =>
      new AggregateDataverseChartDataSource({
        tableName: 'opportunity',
        groupByColumn: 'industrycode',
        groupByLinkedEntity: {
          tableName: 'account',
          from: 'accountid',
          to: 'customerid',
        },
        aggregateColumn: 'estimatedvalue',
        aggregate: QueryAggregate.Sum,
        singleSeriesLabel: t(`${STRINGS_BASE}.series-revenue`),
      }),
    [t],
  );
  return (
    <>
      <DataverseChart
        dataSource={source}
        type={ChartType.Bar}
        title={t(`${STRINGS_BASE}.chart-title`)}
        yAxisPrefix="$"
        onElementClick={setLastClick}
      />
      {lastClick && (
        <p style={{ marginTop: '12px' }}>
          <strong>{t(`${STRINGS_BASE}.clicked-label`)}:</strong>{' '}
          {lastClick.label} — ${lastClick.value.toLocaleString()}
        </p>
      )}
    </>
  );
}
